import { lazy } from 'react';
const WrkstationInquiry = lazy(() => import('./WrkstationInquiry'));

const WrkstationInquiryRoutes = [
  {
    path: '/wrkstationinquiry',
    component: WrkstationInquiry
  }
];

export default WrkstationInquiryRoutes;
